(function () {
  'use strict';

  // GTM normally creates dataLayer before this asset runs, but local/theme
  // preview ordering can differ. Keep tracking isolated and safe to load.
  window.dataLayer = window.dataLayer || [];

  var VERSION = '1.0.0';
  var DEBUG = /[?&]comu_tracking_debug=1/.test(window.location.search);

  var dataEl = document.getElementById('comu-tracking-data');
  if (!dataEl) return;

  var bootstrapData;
  try { bootstrapData = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var currency = bootstrapData.currency || 'USD';
  var pageType = bootstrapData.page_type || '';
  var template = bootstrapData.template || '';

  // --- Cart snapshot ---
  var cartSnapshot = {};
  if (bootstrapData.cart && bootstrapData.cart.items) {
    bootstrapData.cart.items.forEach(function (item) {
      cartSnapshot[String(item.variant_id)] = {
        quantity: item.quantity,
        product_id: item.product_id,
        title: item.title,
        variant_title: item.variant_title,
        sku: item.sku,
        price: item.price,
        handle: item.handle
      };
    });
  }

  // --- Current product state (PDP) ---
  var currentProduct = bootstrapData.product || null;
  var currentVariantId = currentProduct ? currentProduct.variant.id : null;

  // --- Utilities ---
  function uid() {
    return (Date.now().toString(36) + Math.random().toString(36).slice(2, 8));
  }

  function log() {
    if (!DEBUG) return;
    var args = ['[ComuTracking]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function meta(extra) {
    var obj = {
      schema_version: '1.0',
      source: 'comu_theme',
      event_id: uid(),
      page_type: pageType,
      template: template
    };
    if (extra) {
      for (var k in extra) { if (extra.hasOwnProperty(k)) obj[k] = extra[k]; }
    }
    return obj;
  }

  function push(eventName, params) {
    try {
      var payload = { event: eventName, tracking: meta() };
      if (params) {
        for (var k in params) { if (params.hasOwnProperty(k)) payload[k] = params[k]; }
      }
      window.dataLayer.push(payload);
      log('push', eventName, payload);
    } catch (e) { log('error push', e); }
  }

  function pushEcommerce(eventName, ecommerce, extraMeta) {
    try {
      window.dataLayer.push({ ecommerce: null });
      var payload = {
        event: eventName,
        tracking: meta(extraMeta),
        ecommerce: ecommerce
      };
      window.dataLayer.push(payload);
      log('pushEcommerce', eventName, payload);
    } catch (e) { log('error pushEcommerce', e); }
  }

  function buildItemFromVariant(variantData, productData) {
    var sku = variantData.sku || String(variantData.id);
    var variantTitle = variantData.title;
    if (variantTitle === 'Default Title') variantTitle = '';
    return {
      item_id: sku,
      item_name: productData.title,
      item_brand: productData.vendor || 'COMU',
      item_category: productData.type || '',
      item_variant: variantTitle,
      price: variantData.price,
      quantity: 1,
      shopify_product_id: String(productData.id),
      shopify_variant_id: String(variantData.id),
      product_handle: productData.handle
    };
  }

  function normalizeAjaxItem(ajaxItem) {
    var variantTitle = ajaxItem.variant_title || '';
    if (variantTitle === 'Default Title') variantTitle = '';
    return {
      item_id: ajaxItem.sku || String(ajaxItem.variant_id || ajaxItem.id),
      item_name: ajaxItem.product_title || ajaxItem.title || '',
      item_brand: ajaxItem.vendor || 'COMU',
      item_category: ajaxItem.product_type || '',
      item_variant: variantTitle,
      price: (ajaxItem.final_price || ajaxItem.price || 0) / 100,
      quantity: ajaxItem.quantity || 1,
      shopify_product_id: String(ajaxItem.product_id || ''),
      shopify_variant_id: String(ajaxItem.variant_id || ajaxItem.id || ''),
      product_handle: ajaxItem.handle || ''
    };
  }

  // === EVENT: view_item ===
  if (pageType === 'product' && currentProduct) {
    var viewItem = buildItemFromVariant(currentProduct.variant, currentProduct);
    pushEcommerce('view_item', {
      currency: currency,
      value: currentProduct.variant.price,
      items: [viewItem]
    });
  }

  // === EVENT: add_to_cart (via variant:add) ===
  document.addEventListener('variant:add', function (event) {
    try {
      var detail = event.detail || {};
      var items = detail.items || (detail.item ? [detail.item] : []);
      if (!items.length) return;

      var gaItems = items.map(function (item) { return normalizeAjaxItem(item); });
      var totalValue = gaItems.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);

      pushEcommerce('add_to_cart', {
        currency: currency,
        value: totalValue,
        items: gaItems
      });

      // Update cart snapshot
      if (detail.cart && detail.cart.items) {
        cartSnapshot = {};
        detail.cart.items.forEach(function (ci) {
          cartSnapshot[String(ci.variant_id || ci.id)] = {
            quantity: ci.quantity,
            product_id: ci.product_id,
            title: ci.product_title || ci.title,
            variant_title: ci.variant_title,
            sku: ci.sku,
            price: (ci.final_price || ci.price || 0) / 100,
            handle: ci.handle
          };
        });
      }
    } catch (e) { log('error add_to_cart', e); }
  });

  // === EVENT: comu_variant_select ===
  document.addEventListener('variant:change', function (event) {
    try {
      var detail = event.detail || {};
      var variant = detail.variant;
      var previousVariant = detail.previousVariant;
      if (!variant || !previousVariant) return;
      if (variant.id === previousVariant.id) return;

      var variantTitle = variant.title || '';
      if (variantTitle === 'Default Title') variantTitle = '';

      push('comu_variant_select', {
        item_id: variant.sku || String(variant.id),
        shopify_product_id: currentProduct ? String(currentProduct.id) : '',
        shopify_variant_id: String(variant.id),
        previous_shopify_variant_id: String(previousVariant.id),
        variant_name: variantTitle
      });

      // Update current variant cache
      if (currentProduct) {
        var found = currentProduct.variants.find(function (v) { return v.id === variant.id; });
        if (found) {
          currentProduct.variant = found;
          currentVariantId = found.id;
        }
      }
    } catch (e) { log('error variant_select', e); }
  });

  // === EVENT: cart:change → remove_from_cart / view_cart update ===
  document.documentElement.addEventListener('cart:change', function (event) {
    try {
      var detail = event.detail || {};
      // Skip if this is triggered by variant:add (already handled above)
      if (detail.baseEvent === 'variant:add') {
        // Still update snapshot from the full cart
        if (detail.cart && detail.cart.items) {
          var newSnapshot = {};
          detail.cart.items.forEach(function (ci) {
            newSnapshot[String(ci.variant_id || ci.id)] = {
              quantity: ci.quantity,
              product_id: ci.product_id,
              title: ci.product_title || ci.title,
              variant_title: ci.variant_title,
              sku: ci.sku,
              price: (ci.final_price || ci.price || 0) / 100,
              handle: ci.handle
            };
          });
          cartSnapshot = newSnapshot;
        }
        return;
      }

      if (!detail.cart || !detail.cart.items) return;

      var newSnapshot = {};
      detail.cart.items.forEach(function (ci) {
        newSnapshot[String(ci.variant_id || ci.id)] = {
          quantity: ci.quantity,
          product_id: ci.product_id,
          title: ci.product_title || ci.title,
          variant_title: ci.variant_title,
          sku: ci.sku,
          price: (ci.final_price || ci.price || 0) / 100,
          handle: ci.handle
        };
      });

      // Diff: find items with decreased quantity
      var removedItems = [];
      for (var vid in cartSnapshot) {
        if (!cartSnapshot.hasOwnProperty(vid)) continue;
        var oldQty = cartSnapshot[vid].quantity;
        var newQty = (newSnapshot[vid] && newSnapshot[vid].quantity) || 0;
        if (newQty < oldQty) {
          var si = cartSnapshot[vid];
          var variantTitle = si.variant_title || '';
          if (variantTitle === 'Default Title') variantTitle = '';
          removedItems.push({
            item_id: si.sku || vid,
            item_name: si.title || '',
            item_brand: 'COMU',
            item_variant: variantTitle,
            price: si.price,
            quantity: oldQty - newQty,
            shopify_product_id: String(si.product_id || ''),
            shopify_variant_id: vid,
            product_handle: si.handle || ''
          });
        }
      }

      if (removedItems.length) {
        var totalValue = removedItems.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);
        pushEcommerce('remove_from_cart', {
          currency: currency,
          value: totalValue,
          items: removedItems
        });
      }

      cartSnapshot = newSnapshot;
    } catch (e) { log('error cart:change', e); }
  });

  // === EVENT: view_cart ===
  function sendViewCart() {
    var items = [];
    for (var vid in cartSnapshot) {
      if (!cartSnapshot.hasOwnProperty(vid)) continue;
      var si = cartSnapshot[vid];
      var variantTitle = si.variant_title || '';
      if (variantTitle === 'Default Title') variantTitle = '';
      items.push({
        item_id: si.sku || vid,
        item_name: si.title || '',
        item_brand: 'COMU',
        item_variant: variantTitle,
        price: si.price,
        quantity: si.quantity,
        shopify_product_id: String(si.product_id || ''),
        shopify_variant_id: vid,
        product_handle: si.handle || ''
      });
    }
    var totalValue = items.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);
    pushEcommerce('view_cart', {
      currency: currency,
      value: totalValue,
      items: items
    });
  }

  // Cart page
  if (pageType === 'cart') {
    sendViewCart();
  }

  // Cart Drawer / Notification Drawer open detection
  function observeCartDrawer(el) {
    if (!el) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open' && el.hasAttribute('open')) {
          sendViewCart();
        }
      });
    });
    observer.observe(el, { attributes: true, attributeFilter: ['open'] });
  }
  observeCartDrawer(document.querySelector('cart-drawer'));
  observeCartDrawer(document.querySelector('cart-notification-drawer'));

  // === EVENT: comu_component_click (event delegation) ===
  document.addEventListener('click', function (event) {
    try {
      if (!event.isTrusted) return;
      var el = event.target.closest('[data-comu-track-component]');
      if (!el) return;

      // label[for] triggers a second synthetic click on its input; skip that to avoid double-reporting
      if (el.tagName === 'LABEL' && el.htmlFor && event.target !== el && el.contains(event.target) && (event.target.tagName === 'INPUT' || event.target.closest('input'))) return;

      // Skip add-to-cart buttons — they only need add_to_cart event via variant:add
      if (el.hasAttribute('data-comu-sticky-add') || el.hasAttribute('data-comu-pc-action')) return;

      var component = el.getAttribute('data-comu-track-component') || '';
      var placement = el.getAttribute('data-comu-track-placement') || '';
      var label = el.getAttribute('data-comu-track-label') || el.textContent.trim().slice(0, 80) || '';
      var targetUrl = el.getAttribute('data-comu-track-url') || el.getAttribute('href') || '';
      var sectionId = el.getAttribute('data-comu-track-section') || '';

      if (!sectionId) {
        var sectionEl = el.closest('[data-section-id]') || el.closest('.shopify-section');
        if (sectionEl) {
          sectionId = sectionEl.getAttribute('data-section-id') || sectionEl.id || '';
        }
      }

      push('comu_component_click', {
        component: component,
        action: 'click',
        placement: placement,
        label: label,
        target_url: targetUrl,
        section_id: sectionId,
        product_handle: currentProduct ? currentProduct.handle : ''
      });
    } catch (e) { log('error component_click', e); }
  });

  // === EVENT: Kaching Bundles interaction (third-party App DOM) ===
  document.addEventListener('click', function (event) {
    try {
      // Bundle bar selection (deal radio)
      var bar = event.target.closest('.kaching-bundles__bar-main');
      if (bar) {
        var barEl = bar.closest('[data-deal-bar-id]');
        var dealId = barEl ? barEl.getAttribute('data-deal-bar-id') : '';
        var title = bar.querySelector('.kaching-bundles__bar-title');
        push('comu_component_click', {
          component: 'kaching_bundle_select',
          action: 'click',
          placement: 'bundle_bar',
          label: title ? title.textContent.trim().slice(0, 80) : dealId,
          target_url: '',
          section_id: '',
          product_handle: currentProduct ? currentProduct.handle : ''
        });
        return;
      }

      // Bundle variant swatch selection
      var swatch = event.target.closest('.kaching-bundles__swatch-buttons__button');
      if (swatch) {
        var value = swatch.getAttribute('data-value') || '';
        push('comu_component_click', {
          component: 'kaching_bundle_variant',
          action: 'click',
          placement: 'bundle_swatch',
          label: value,
          target_url: '',
          section_id: '',
          product_handle: currentProduct ? currentProduct.handle : ''
        });
        return;
      }
    } catch (e) { log('error kaching_click', e); }
  });

  // === EVENT: FAQ toggle (details open/close) ===
  document.addEventListener('toggle', function (event) {
    try {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS') return;
      var faqContainer = details.closest('[data-comu-track-faq]');
      if (!faqContainer) return;

      var sectionId = faqContainer.getAttribute('data-comu-track-faq') || '';
      var summary = details.querySelector('summary');
      var label = summary ? summary.textContent.trim().slice(0, 80) : '';

      push('comu_component_click', {
        component: 'product_faq_toggle',
        action: details.open ? 'expand' : 'collapse',
        placement: 'faq',
        label: label,
        target_url: '',
        section_id: sectionId,
        product_handle: currentProduct ? currentProduct.handle : ''
      });
    } catch (e) { log('error faq_toggle', e); }
  }, true);

  // === EVENT: view_item_list / select_item (IntersectionObserver) ===
  var observedCards = new WeakSet();
  var pendingImpressions = {};
  var impressionTimer = null;

  function flushImpressions() {
    for (var listId in pendingImpressions) {
      if (!pendingImpressions.hasOwnProperty(listId)) continue;
      var batch = pendingImpressions[listId];
      if (!batch.items.length) continue;
      var totalValue = batch.items.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);
      pushEcommerce('view_item_list', {
        currency: currency,
        value: totalValue,
        item_list_id: listId,
        item_list_name: batch.listName,
        items: batch.items
      });
    }
    pendingImpressions = {};
    impressionTimer = null;
  }

  function scheduleFlush() {
    if (impressionTimer) return;
    impressionTimer = setTimeout(flushImpressions, 200);
  }

  function handleItemIntersection(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var card = entry.target;
      if (observedCards.has(card)) return;
      observedCards.add(card);

      var itemJsonStr = card.getAttribute('data-item-json');
      if (!itemJsonStr) return;
      try {
        var item = JSON.parse(itemJsonStr);
        var listId = item.item_list_id || 'unknown';
        var listName = item.item_list_name || '';
        if (!pendingImpressions[listId]) {
          pendingImpressions[listId] = { listName: listName, items: [] };
        }
        pendingImpressions[listId].items.push(item);
        scheduleFlush();
      } catch (e) { log('error parsing item json', e); }
    });
  }

  var itemObserver = null;
  if (typeof IntersectionObserver !== 'undefined') {
    itemObserver = new IntersectionObserver(handleItemIntersection, { threshold: 0.5 });
  }

  function scanItemCards(root) {
    if (!itemObserver) return;
    var cards = (root || document).querySelectorAll('[data-comu-track-item]');
    cards.forEach(function (card) {
      if (!observedCards.has(card)) {
        itemObserver.observe(card);
      }
    });
  }

  // select_item: click on product link within tracked cards
  document.addEventListener('click', function (event) {
    try {
      var link = event.target.closest('[data-comu-track-item] a[href*="/products/"]');
      if (!link) return;
      // Skip Quick Add buttons
      if (link.closest('[data-comu-pc-action]') || link.hasAttribute('data-comu-pc-action')) return;

      var card = link.closest('[data-comu-track-item]');
      if (!card) return;

      var itemJsonStr = card.getAttribute('data-item-json');
      if (!itemJsonStr) return;
      var item = JSON.parse(itemJsonStr);

      pushEcommerce('select_item', {
        currency: currency,
        item_list_id: item.item_list_id || '',
        item_list_name: item.item_list_name || '',
        items: [item]
      });
    } catch (e) { log('error select_item', e); }
  });

  // === EVENT: generate_lead ===
  var leadEl = document.querySelector('[data-comu-track-lead-success]');
  if (leadEl) {
    push('generate_lead', {
      lead_type: leadEl.getAttribute('data-comu-track-lead-type') || 'contact',
      placement: leadEl.getAttribute('data-comu-track-lead-placement') || ''
    });
  }

  // === EVENT: video play modal button (click intercepted by modal logic) ===
  document.querySelectorAll('[data-comu-vt-modal-open][data-comu-track-component]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      try {
        push('comu_component_click', {
          component: btn.getAttribute('data-comu-track-component') || '',
          action: 'click',
          placement: btn.getAttribute('data-comu-track-placement') || 'modal',
          label: btn.getAttribute('data-comu-track-label') || '',
          target_url: '',
          section_id: btn.getAttribute('data-comu-track-section') || '',
          product_handle: currentProduct ? currentProduct.handle : ''
        });
      } catch (e) { log('error video_modal_click', e); }
    });
  });

  // === EVENT: comu_component_view (IntersectionObserver) ===
  var observedComponents = new WeakSet();
  var componentObserver = null;
  if (typeof IntersectionObserver !== 'undefined') {
    componentObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (observedComponents.has(el)) return;
        observedComponents.add(el);
        componentObserver.unobserve(el);

        var component = el.getAttribute('data-comu-view-component') || '';
        var placement = el.getAttribute('data-comu-view-placement') || '';
        var label = el.getAttribute('data-comu-view-label') || '';
        var sectionId = el.getAttribute('data-comu-track-section') || '';
        if (!sectionId) {
          var sectionEl = el.closest('[data-section-id]') || el.closest('.shopify-section');
          if (sectionEl) sectionId = sectionEl.getAttribute('data-section-id') || sectionEl.id || '';
        }

        push('comu_component_view', {
          component: component,
          action: 'view',
          placement: placement,
          label: label,
          section_id: sectionId
        });
      });
    }, { threshold: 0.5 });
  }

  function scanComponentViews(root) {
    if (!componentObserver) return;
    (root || document).querySelectorAll('[data-comu-track-view]').forEach(function (el) {
      if (!observedComponents.has(el)) componentObserver.observe(el);
    });
  }

  // === Initial scan + Theme Editor reload support ===
  scanItemCards(document);
  scanComponentViews(document);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section) {
      scanItemCards(section);
      scanComponentViews(section);
    }
  });

  // === Public API ===
  window.ComuTracking = {
    version: VERSION,
    push: push,
    pushEcommerce: pushEcommerce,
    normalizeAjaxItem: normalizeAjaxItem,
    trackAddToCart: function (items) {
      if (!items || !items.length) return;
      var gaItems = items.map(function (item) { return normalizeAjaxItem(item); });
      var totalValue = gaItems.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);
      pushEcommerce('add_to_cart', {
        currency: currency,
        value: totalValue,
        items: gaItems
      });
    },
    scan: scanItemCards,
    scanViews: scanComponentViews
  };

  log('initialized', VERSION, { pageType: pageType, template: template });
})();
